import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { TipoDocumentoForm } from "./TipoDocumentoForm";
import { useGetTipoDocumentoQuery, useUpdateTipoDocumentoMutation } from "./tipoDocumentoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useParams } from "react-router-dom";
import { errorMonitor } from "events";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { IStipoDocumento, TipoDocumento } from "../../types/tipoDocumento/TipoDocumento";



export const TipoDocumentoEdit = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()


    const [updateTipoDocumento, status] = useUpdateTipoDocumentoMutation();


    const id = useParams().id || "";
    const { data, isFetching, error } = useGetTipoDocumentoQuery(id);
    const [tipoDocumento, setTipoDocumento] = useState<TipoDocumento>(IStipoDocumento);


    useEffect(() => {
        if (data) {
            setTipoDocumento(data);
        } else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        } else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        } else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }
    }, [data, error, isFetching])




    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setTipoDocumento((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };
    const handleCorpoChangeQuill = (value: string) => {
        setTipoDocumento((prev) => ({
            ...prev,
            conteudo: value,
        }));
        console.log("REact quill value", value);
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await updateTipoDocumento(tipoDocumento);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não alterado!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro alterado com sucesso!", { variant: "success" })
            navigate(configUrls.TIPO_DOCUMENTO_LIST_RT);
        }
    }, [status]);


    return (
        <>
            <Paper >

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Tipos de Documentos - Edição
                </Typography>

                <TipoDocumentoForm
                    data={tipoDocumento}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleCorpoChangeQuill={handleCorpoChangeQuill}
                />
            </Paper>
        </>
    );
};
